import { takeLatest } from 'redux-saga/effects';
import { GET_CASE_START, FOLLOW_MY_CASE_START } from 'redux/actions/types';
import { getCaseSaga } from './case-saga';
import { followMyCaseSaga } from './follow-my-case-saga';

export default function* currentNotificationSagas() {
  yield takeLatest(GET_CASE_START, getCaseSaga);
  yield takeLatest(FOLLOW_MY_CASE_START, followMyCaseSaga);
}
